import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { useFormik, FormikProvider, FieldArray } from "formik";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";

const DecayLoadingView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});
  const [paymentMethods, setPaymentMethods] = useState([]);  
  // const [paymentStatus, setPaymentStatus] = useState([]);
  const [backendErrors, setBackendErrors] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('');
     let season_id = localStorage.getItem("season_id");
  const [productLists, setproductLists] = useState([]);
  const [valuecontents, setValuecontents] = useState([]);

    const formik = useFormik({
      initialValues: {
       season_id:season_id,
        id: value.id,
        currency: value.currency,
       // price: value.price ,
        payment_method:value.payment_method,
        payment_status:value.payment_status,
        items:valuecontents
      },
      enableReinitialize: true,
      //validationSchema: EditUserSchema,
      onSubmit: (values , { setSubmitting }) => {
        axios
          .post("/decay-sale-loadings/update-price", values, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
          .then((response) => {

           // console.log(response);
           
            delete backendErrors['error'];
            setSubmitting(false);
            // actions.setSubmitting(false);
            $("#form-submit").text("Update Sale Loading");
             if (response.data.code === 200) {
               toast.success(response.data.message);
            //   actions.resetForm();
               setTimeout(() => {
                 window.location.href = "/decay-loading";
               }, 1000);
             }  else if (response.data.code === 422) {
                 setBackendErrors(response.data.error);
             }
             else if (response.data.code === 401) {
               setBackendErrors(response.data.error);
             }
             else {
                setBackendErrors(response.data.error);
             }
          })
          .catch((error) => {
            console.log(error);
          });
      },
    });
  useEffect(() => {
        setPermission(FindModuleById(450)); 
    console.log(permission);
 axios
    .post(
      "/products/listing-category-type",
      {},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
    .then((response) => {
      if (response.data.code === 200) {
        let products = response.data.data.products;
        let productslisting = products.map((customer, index) => ({
          label: customer.productname,
          value: customer.id,
          key: `address-${index}`,
        }));
        setproductLists(productslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
    axios
      .get(`/decay-sale-loadings/edit/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.sale);
         
          const currencydetail = primaryCurrency.find(item => item.value === response.data.data.sale.currency) || null;
          setCurrencySymbol(currencydetail ? currencydetail.symbol : 'dh');
            setValuecontents(response.data.data.sale.items);
      
        }
      })
      .catch((error) => {
        console.log(error);
      });


          axios
            .get(`/helpers/expenses-payment-methods`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              if (response.data.code === 200) {
                let types = response.data.data.methods;
                let typeslisting = types.map((ord, index) => ({
                  label: ord.title,
                  value: ord.id,
                  key: `location-${index}`,
                }));
                setPaymentMethods(typeslisting);
              } else {
                console.log("API response is not an array");
              }
            })
            .catch((error) => {
              console.log(error);
            });
                 

  }, [id]);
 const primaryCurrency =  [
    {
        "label": "EUR",
        "value": 1,
        "symbol": "€",
        "key": "cabrane-0"
    },
    {
        "label": "USD",
        "value": 2,
        "symbol": "$",
        "key": "cabrane-1"
    },
    {
        "label": "GBP",
        "value": 3,
        "symbol": "£",
        "key": "cabrane-2"
    },
    {
        "label": "MAD ",
        "value": 4,
        "symbol": "dh",
        "key": "cabrane-3"
    }
];
 
  const paymentStatus =[
 
    {
      "value": 0,
      "label": "PENDING",
      "color": "white",
      "bg_color": "red",
  },
  {
    "value":1,
    "label": "PAID",
    "color": "white",
    "bg_color": "green",
},
  ];
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
    
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  const customFuction = (event) =>{
    console.log(event)
    // var index = event.target.selectedIndex;
    // var optionElement = event.target.childNodes[index];
    // var key_sybmol =  optionElement.getAttribute('key_sybmol');
    // console.log(key_sybmol);
    setCurrencySymbol(event.symbol)
   
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /> <ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-10">
                  <h3 className="page-title">Decay Loading</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/decay-sales">Decay Loading</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Loading Sale
                    </li>
                  </ul>
                </div>
                {/* <div className="col-sm-2">
                  <div style={{float:"right"}}>
                      <button   onClick={() => downloadDecaySaleInvocie()}   className="btn btn-primary me-1"  > Download Invoice <i className="fa fa-download" /> <img id="loader-image2" className="loader-image loader-hide" src={loader_image}/>  </button>
                    </div>  
                </div> */}

              </div>
            </div>

            <div className="row">
              <div className="col-md-12 " id="printablediv"> 
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">View Loading Sale Info</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Date</th>
                        <td className="p-3">{value.date_time}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Customer </th>
                        <td className="p-3">
                          {value.customer ? value.customer.name : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Driver Plate Number</th>
                        <td className="p-3">{value.driver_plate_number}</td>
                      </tr>
                      
                    
                      <tr>
                        <th className="p-3">Note</th>
                        <td className="p-3">{value.note}</td>
                      </tr>
                    </table>
                    <br />
                   
                  </div>
                </div>
              </div>
            </div>
           
          
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card">
                            <div className="card-body">
                              <h4 className="card-title">Decay Loading Update Price</h4>
                              {permission && permission.update == 1 && (
                              <FormikProvider value={formik}>
                              <form onSubmit={formik.handleSubmit}>
                                
                              
                              <div className="row">
                                  
                              
                              <div className="col-md-4">
                                    <div className="form-group status2">
                                      <label>Select Currency</label>
                                      {primaryCurrency.length > 0 && (
                                        <Select
                                        className="w-100"
                                        value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                        name="currency"
                                         //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                         onChange={(selectedOption) => {
                                          handleSelectChange("currency", selectedOption);
                                          customFuction(selectedOption);
                                        }}
                                        onBlur={formik.handleBlur}
                                        options={primaryCurrency}
                                        placeholder="Select"
          
                                          
                                        />
                                      )}
                                      
                                      
                                      <small>
                                        {backendErrors.currency && (
                                            <span className="form-error mt-1">
                                              {backendErrors.currency}
                                            </span>
                                          )}
                                      </small>
                                      </div>
                                     
                                    </div>


                             
                                  <div className="col-md-4">
                                    <div className="form-group status">
                                        <label>Select Payment Method</label>
                                        {paymentMethods.length > 0 && (
                                          <Select
                                          className="w-100"
                                         value={paymentMethods.find(option => option.value == formik.values.payment_method) || null} // Ensure correct format
                                         name="payment_method"
                                          onChange={(selectedOption) => handleSelectChange("payment_method", selectedOption)}
                                         onBlur={formik.handleBlur}
                                         options={paymentMethods}
                                         placeholder="Select"
          
                                        />
                                        )}
                                        
                                        <small>
                                          {backendErrors.payment_method && (
                                              <span className="form-error mt-1">
                                                {backendErrors.payment_method}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                  </div>
          
                                  <div className="col-md-4">
                                    <div className="form-group status">
                                        <label>Select Payment Status</label>
                                        {paymentStatus.length > 0 && (
                                          <Select
                                          className="w-100"
                                          value={paymentStatus.find(option => option.value == formik.values.payment_status) || null} // Ensure correct format
                                          name="payment_status"
                                           onChange={(selectedOption) => handleSelectChange("payment_status", selectedOption)}
                                          onBlur={formik.handleBlur}
                                          options={paymentStatus}
                                          placeholder="Select"
                                        />
                                        )}
                                        
                                        <small>
                                          {backendErrors.payment_status && (
                                              <span className="form-error mt-1">
                                                {backendErrors.payment_status}
                                              </span>
                                            )}
                                        </small>
                                      </div>
                                  </div>
                                </div>

<FieldArray
                        name="items"
                        render={() => (
                          <div style={{overflow:"auto2"}}>
                           

                            <table className="table table-padding">
                                <thead>
                                  <tr>
                                  <th>Product</th>
                                    <th>Net Weight</th>
                                    <th>Price</th>
                                    <th></th>
                                 
                                  </tr>
                                </thead>
                             
                              <tbody>
                                {formik.values.items.map(
                                  (friend, index) => (
                                    <tr key={index}>
                                    
                                      <td  >
                                        <div className="form-group status">
                                        {productLists.length > 0 && (
                                          <Select
                                            name={`items[${index}].product`}
                                            options={productLists}
                                            value={productLists.find(
                                              (option) => option.value == formik.values.items[index].product
                                            ) || null}
                                            onChange={(selectedOption) => {
                                              formik.setFieldValue(`items[${index}].product`, selectedOption.value);
                                              customHandleInput({
                                                target: {
                                                  name: `items[${index}].product`,
                                                  value: selectedOption.value,
                                                },
                                              });
                                            }}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select"
                                            className="w-100"
                                            menuIsOpen={false} // 👈 hides dropdown
                                            isDisabled // 👈 prevents editing
                                          />

                                         )}
                                          
                                        </div>
                                      </td>
                                   
                                      <td >
                                        <div className="form-group">
                                        
                                          <div className="input-group" >
                                              <input type="text"  
                                              name={`items[${index}].quantity`}
                                              onKeyPress={(event) => {
                                                // Prevent non-numeric input for keypress
                                                if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                  event.preventDefault();
                                                }
                                              }}
                                              value={
                                                formik.values.items[index]
                                                  .quantity
                                              }
                                            
                                              onChange={(e) => {
                                                formik.handleChange(e);
                                              }}
                                              onBlur={formik.handleBlur}
                                              className="form-control" placeholder="Net Weight"
                                              
                                              readOnly disabled/>
                                            
                                          </div>
                                        </div>
                                      </td>
                                      <td >
                                        <div className="form-group">
                                        
                                          <div className="input-group" >
                                              <input type="text"  
                                              name={`items[${index}].price`}
                                              onKeyPress={(event) => {
                                                // Prevent non-numeric input for keypress
                                                if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                  event.preventDefault();
                                                }
                                              }}
                                              value={
                                                formik.values.items[index]
                                                  .price
                                              }
                                            
                                              onChange={(e) => {
                                                formik.handleChange(e);
                                              }}
                                              onBlur={formik.handleBlur}
                                              className="form-control"  placeholder="Price"  
                                               aria-label="Price" aria-describedby="basic-addon2" />
                                          <div className="input-group-append">
                                              <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                          </div>
                                              
                                          </div>
                                        </div>
                                      </td>
                                     
                                     
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      />          
                             
          
                                <div className="text-end mt-4">
                                  <button className="btn btn-primary" type="submit" id="form-submit"  disabled={formik.isSubmitting}>
                                  Update Decay Sale
                                  </button>
                                </div>
                              </form>
                            </FormikProvider>
                          )}
                        </div>
                          </div>
                        </div>
                      </div>
           
          </div>
        </div>
      </div>
    </>
  );
};
export default DecayLoadingView;
